module.exports = __webpack_public_path__ + "img/register2.54581814.svg";